import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/inventory-purchases/profile/loading';

export const Route = createFileRoute('/_private/settings/inventory-purchases/$id')({
  pendingComponent: Loading,
});
